import React from "react";
import { Link } from "react-router-dom";

function EmailVerifiedPage() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 w-full max-w-md mx-4">
                <div className="text-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">Email Verified</h2>
                    <p className="text-gray-600 mt-1">
                        Your email has been successfully verified!
                    </p>
                </div>
                
                <div className="p-4 bg-green-50 border border-green-200 rounded-md mb-6">
                    <p className="text-green-700 text-center">
                        You can now log in to your account and access all features.
                    </p>
                </div>
                
                <div className="text-center">
                    <Link
                        to="/login"
                        className="inline-block w-full bg-indigo-600 text-white py-2 px-4 rounded-md font-medium hover:bg-indigo-700 transition duration-200"
                    >
                        Go to Login
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default EmailVerifiedPage;